import React from 'react';
import { TileLayer, type TileLayerProps } from 'react-leaflet';
import './coffeeLeafletMap.css';

/** Carto Voyager tiles — muted labels read well under our warm sepia filter (see coffeeLeafletMap.css). */
const CARTO_VOYAGER_TEMPLATE =
    'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';

const DEFAULT_ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

/** Put this class on react-leaflet `MapContainer` next to CoffeeMapBasemap. */
export const COFFEE_MAP_CONTAINER_CLASS = 'coffee-map-tone';

type Props = Omit<TileLayerProps, 'url' | 'attribution'> &
    Partial<Pick<TileLayerProps, 'attribution' | 'url'>>;

/**
 * Shared coffee-map base layer + stylesheet for warm-brown styling.
 * Parent `MapContainer` should set `className` to include COFFEE_MAP_CONTAINER_CLASS.
 */
export function CoffeeMapBasemap({
    attribution = DEFAULT_ATTRIBUTION,
    url = CARTO_VOYAGER_TEMPLATE,
    ...rest
}: Props) {
    return <TileLayer attribution={attribution} url={url} {...rest} />;
}
